import { Helmet } from "react-helmet";
import { Container, Box, Grid } from "@mui/material";
import { IoIosArrowForward } from "react-icons/io";

/* imagenes */

import prin from "../../../img/sostenibilidad/innovacion/principal.png";
import tit from "../../../img/sostenibilidad/innovacion/titulo.png";
import crea from "../../../img/sostenibilidad/innovacion/crea.png";
import api from "../../../img/sostenibilidad/innovacion/apli.png";
import con from "../../../img/sostenibilidad/innovacion/_con.png"


export default function IndexInnovacion () {
    return(
        <>
          <Helmet>
        <title>Axinntus | Inclusión y diversidad</title>
        <meta
          name="description"
          content="IEn Axinntus, entendemos que la multiculturalidad en nuestros equipos enriquece nuestra capacidad para ofrecer servicios de excelencia."
        />
        <meta
          name="keywords"
          content="axinntus, operación industriales, servicios , personas, equipos,  estándares de seguridad, servicios a la medida, operación."
        />
      </Helmet>
      <Container  maxWidth="xl" >
      <div
          className="paginacompleta"
    
  >
        <div
          style={{ display: "flex", alignItems: "center", fontSize: "0.8rem" }}
        >
          {" "}
          <p style={{ fontWeight: "400", color: "#898b8a" }}>
            {" "}
           Sostenibilidad
          </p>{" "}
          <IoIosArrowForward
            style={{
              marginLeft: "10px",
              marginRight: "10px",
              color: "#6f7170",
            }}
          />{" "}
          <strong style={{ color: "#6f7170" }}>
     
    Innovación</strong>
        </div>
    </div>
      
      </Container>
      <section style={{background:'#fcfbfc'}}>
      <Container maxWidth="xxl">
        <Box
        sx={{display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
         
            <img src={prin} alt="axinntus innovacion" title="axinntus innovacion" width="100%" height="100%" />
         
             
              </Box>
      </Container>
    </section>
          <Container maxWidth='lg'>
            <Box
        sx={{display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column',}}>
          <Box sx={{width:'90%', mt:2}}>
             <img src={tit} alt="axinntus innovacion" title="axinntus innovacion" width="100%" height="100%" />
             </Box>
            <Box sx={{
              mt:5
            }}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={4}>
                 
                    <img src={crea} alt="axinntus innovacion" title="axinntus innovacion" width="100%" height="100%" />
                    
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                 
                    <img src={con} alt="axinntus innovacion" title="axinntus innovacion" width="100%" height="100%" />
                    
                </Grid>
                 <Grid item xs={12} sm={6} md={4}>
                 
                    <img src={api} alt="axinntus innovacion" title="axinntus innovacion" width="100%" height="100%" />
                    
                </Grid>
              </Grid>
             
            </Box>
        </Box>
          </Container>
    
    
        </>
    )
}